const sharePermissions = [
  { id: 'full', title: 'full' },
  { id: 'privacyProtected', title: 'privacyProtected' },
  { id: 'disabled', title: 'disabled' },
];

export default sharePermissions;